const processSteps = [
  {
    num: '1',
    title: '온라인 견적',
    desc: '사진, 크기, 원하는 구성으로\n디자인과 견적을 먼저 확인하세요.',
    highlight: '사진, 크기, 원하는 구성',
  },
  {
    num: '2',
    title: '현장 실사',
    desc: '현장 점검 및 실측 후\n최종 디자인을 받아보세요.',
    highlight: '현장 점검 및 실측',
  },
  {
    num: '3',
    title: '계약과 제작',
    desc: '제작 및 설치까지\n2~4주가 소요됩니다.',
    highlight: '제작 및 설치',
  },
  {
    num: '4',
    title: '완성',
    desc: '축하드려요!\n유지보수는 계약일로부터 1년간 보장됩니다.',
    highlight: '1년',
  },
];

export default function ProcessSection() {
  return (
    <section className="w-full bg-gray-50 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <p className="text-base text-gray-500 mb-1">마지막으로,</p>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 leading-snug">
            대구싱크대 키친스의 주방이 완성되는 4단계
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg p-8 border border-gray-100 relative"
            >
              <span className="text-4xl font-black text-yellow-400">{step.num}</span>
              <h3 className="text-lg font-bold text-gray-900 mt-3 mb-4">{step.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed whitespace-pre-line">{step.desc}</p>
              {idx < processSteps.length - 1 && (
                <div className="hidden lg:flex absolute -right-3 top-1/2 -translate-y-1/2 w-6 h-6 items-center justify-center z-10">
                  <i className="ri-arrow-right-s-line text-gray-400 text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
